import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { accessLocalStorage, requestToken, validEmail, validPassword } from '../../services';
import { buildSession, isValidSession } from '../../services/session';
import PbxContext from '../../context/PbxContext';
import logo from '../../img/logo.png';
import './styles.css';

function Login() {
  const getItensStateGlobal = useContext(PbxContext);
  const { setUser, setPath } = getItensStateGlobal;
  const [notification, setNotification] = useState(true);
  const [emailLocal, setEmailLocal] = useState('');
  const [password, setPassword] = useState('');
  const [disable, setDisable] = useState(true);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const history = useHistory();

  const verifyUserLogged = async () => {
    const stored = accessLocalStorage.getUserLocalStorage();
    if (isValidSession(stored)) {
      setPath('/home');
      history.push('home');
    }
  }

  const handleClick = async () => {
    setLoading(true);
    const ipRequest = window.location.href;

    const successCode = 200;
    const userData = { email: emailLocal, password };
    const response = await requestToken(userData, ipRequest);

    setLoading(false);

    if (!response || response.status !== successCode) return setNotification(false);
    if (!isValidSession(response.data)) return setNotification(false);

    accessLocalStorage.setUserLocalStorage(buildSession(response.data, ipRequest));
    setUser(response.data.user);
    setPath('/home')
    history.push('home');
  };

  useEffect(() => {
    verifyUserLogged();
  }, []);

  useEffect(() => {
    const validateData = () => {
      const validLocalEmail = validEmail(emailLocal);
      const validLocalPass = validPassword(password);
      if (validLocalEmail && validLocalPass) {
        return setDisable(false);
      }
      return setDisable(true);
    }
    validateData();
  }, [emailLocal, password]);

  return (
    <div className="login-container">
      <div className="login-background">
        <div className="login-circles">
          <div className="circle circle-1"></div>
          <div className="circle circle-2"></div>
          <div className="circle circle-3"></div>
        </div>
      </div>

      <div className="login-card">
        <div className="login-card-inner">
          <div className="login-header">
            <div className="logo-container">
              <img src={logo} alt="Vigos" className="login-logo" />
            </div>
            <h1 className="login-title">Bem-vindo de volta</h1>
            <p className="login-subtitle">Entre com suas credenciais para acessar</p>
          </div>

          <form 
            className="login-form"
            onSubmit={(e) => e.preventDefault()}
            onKeyPress={(e) => e.key === "Enter" && !disable && !loading ? handleClick() : null}
          >
            {!notification && (
              <div className="error-message">
                <svg className="error-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span>Email ou senha inválidos</span>
                <button 
                  type="button"
                  className="error-close" 
                  onClick={() => setNotification(true)}
                >
                  ×
                </button>
              </div>
            )}

            <div className="form-group">
              <label className="form-label">
                <svg className="label-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
                </svg>
                E-mail
              </label>
              <div className="input-wrapper">
                <input
                  className="form-input"
                  type="email"
                  placeholder="seu@email.com"
                  value={emailLocal}
                  onChange={(e) => setEmailLocal(e.target.value)}
                  autoComplete="email"
                />
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">
                <svg className="label-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
                Senha
              </label>
              <div className="input-wrapper password-wrapper">
                <input
                  className="form-input"
                  type={showPassword ? "text" : "password"}
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex={-1}
                >
                  {showPassword ? (
                    <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                    </svg>
                  ) : (
                    <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                    </svg>
                  )}
                </button>
              </div>
            </div>

            <button
              type="submit"
              className={`login-button ${loading ? 'loading' : ''}`}
              onClick={handleClick}
              disabled={disable || loading}
            >
              {loading ? (
                <span className="button-spinner"></span>
              ) : (
                <>
                  <span>Entrar</span>
                  <svg className="button-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                  </svg>
                </>
              )}
            </button>
          </form>

          <div className="login-footer">
            <p>© 2026 Vigos Cloud. Todos os direitos reservados.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
